module.exports = __webpack_public_path__ + "img/everone-prize.61e0cd83.png";